import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPurpleDownloadIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2 10.5C2 12.3856 2 13.3284 2.58579 13.9142C3.17157 14.5 4.11438 14.5 6 14.5H10C11.8856 14.5 12.8284 14.5 13.4142 13.9142C14 13.3284 14 12.3856 14 10.5",
		fill: "transparent",
		stroke: "#A020FF",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.00016 2.5013V11.168M8.00016 11.168L10.6668 8.2513M8.00016 11.168L5.3335 8.2513",
		stroke: "#A020FF",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgPurpleDownloadIcon;
